
import i18n from "../../../../i18n";

const IncidentID = i18n.t('manageAutomation.IncidentID');
const AssignedTo = i18n.t('manageAutomation.AssignedTo');
const Status = i18n.t('manageAutomation.Status');
const Priority = i18n.t('manageAutomation.Priority');
const Severity = i18n.t('manageAutomation.Severity');
const AlertName = i18n.t('manageAutomation.AlertName');
const Context = i18n.t('manageAutomation.Context');
const TicketType = i18n.t('manageAutomation.TicketType');
const Client = i18n.t('manageAutomation.Client');
const UpdatedOn = i18n.t('manageAutomation.UpdatedOn');
const ShortDescription = i18n.t('manageAutomation.ShortDescription');
const IncidentURL = i18n.t('manageAutomation.IncidentURL');
const SysId= i18n.t('manageAutomation.SysId');
const AssignmentGp= i18n.t('manageAutomation.AssignmentGp');

const INCIDENTS_USER_HEADERS = [
  {
    key: 'incidentId',
    header: IncidentID,
    hidden: false,
    optional: false
  },
  {
    key: 'incidentStatus',
    header: Status,
    hidden: false,
    optional: false
  },
  {
    key: 'assigned_to',
    header: AssignedTo,
    hidden: true,
    optional: true
  },
  {
    key: 'priority',
    header: Priority,
    hidden: false,
    optional: false
  },
  {
    key: 'alertName',
    header:ShortDescription,
    hidden: false,
    optional: false
  },
  {
    key: 'context',
    header: Context,
    hidden: false,
    optional: false
  },
  {
    key: 'ticketType',
    header: TicketType,
    hidden: false,
    optional: false
  },
  {
    key: 'client',
    header: Client,
    hidden: true,
    optional: true
  },
  {
    key: 'updatedOn',
    header: UpdatedOn,
    hidden: false,
    optional: false
  },
  {
    key: 'incidentURL',
    header: IncidentURL,
    hidden: true,
    optional: false
  },
  {
    key: 'sysId',
    header: SysId,
    hidden: true,
    optional: false
  },
  {
    key: 'assignmentGp',
    header: AssignmentGp,
    hidden: true,
    optional: true
  }
];

export default INCIDENTS_USER_HEADERS;